import {
	connect
} from 'react-redux'
import SimpleDataTable from '../components/common/SimpleDataTable.jsx';
import {
	findOrderDetailBespoke
} from '../actions';

const mapStateToProps = (state) => ({
	data: state.getIn(['orderDetailBespokeListReducer', 'orderDetailList']),
	fields: {
		order_detail_id: '編號',
		customer_gear_name: '產品名稱',
		bespoke_hidden: '套量是否隱藏',
	},
	keys: ['order_id', 'order_detail_id', 'gear_name'],
	showEdit: true
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: () => {
	},
	editItem: (pk) => {
		dispatch(findOrderDetailBespoke(pk));
	},
})

const OrderDetailBespokeListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(SimpleDataTable)

export default OrderDetailBespokeListContainer;


// WEBPACK FOOTER //
// ./src/containers/OrderDetailBespokeListContainer.jsx